import { EditIcon, PlusSquareIcon } from '@chakra-ui/icons';
import {
    Alert,
    AlertDescription,
    AlertTitle,
    Badge,
    Box,
    Button,
    Center,
    Divider,
    Heading,
    HStack,
    Table,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tooltip,
    Tr,
    VStack
} from '@chakra-ui/react';
import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { fetchOrderById, updateOrder } from '../../api';
import AccessDenied from '../../components/AccessDenied';
import Loading from '../../components/Loading/Loading';
import { alert, useTableColors } from '../../Utils';
import AddItemsModal from './AddItemsModal'; // Import the new component
import OrdersInternalNotes from './OrdersInternalNotes';


const OrderDetailsUnAssigned = () => {
    const { id } = useParams(); // Get the order ID from the URL
    const [order, setOrder] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [updatedItems, setUpdatedItems] = useState([]);
    const coolors = useTableColors();
    const [isAddItemsModalOpen, setIsAddItemsModalOpen] = useState(false); // Custom state for AddItemsModal
    const [shouldSubmit, setShouldSubmit] = useState(false);

    // Functions to open and close the AddItemsModal
    const openAddItemsModal = () => setIsAddItemsModalOpen(true);
    const closeAddItemsModal = () => setIsAddItemsModalOpen(false);

    const tableRef = useRef();

    const handleNoteAdded = (updatedNotes) => {
        setOrder(prevOrder => ({
            ...prevOrder,
            internalNotes: updatedNotes,
        }));
    };
    useEffect(() => {
        loadOrderDetails(id);
    }, [id]);

    const loadOrderDetails = async (ids) => {
        setLoading(true);
        try {
            const result = await fetchOrderById(ids);
            if (result.success) {
                setOrder(result.data);
                setUpdatedItems(result.data.requestedItems.map(item => ({
                    itemId: item.item._id,
                    quantitySent: item.quantitySent,
                    note: item.note || '',
                    isAvailable: item.isAvailable || false,
                    notSending: item.notSending || false,
                })));

                console.log(result.data)
            } else {
                setError(result.error);
            }
        } catch (error) {
            setError('Failed to load order details', { error });
        }
        setLoading(false);
    };

    const handleSubmit = async (isFinished = false, ignoreValidation = false) => {
        try {

            if (!ignoreValidation) {
                // Check for validation
                const invalidItems = updatedItems.filter(item => {
                    // If quantity is 0, item must be marked as notSending and must have a note
                    if (item.quantitySent === 0 && (!item.notSending || !item.note)) {
                        return true;
                    }
                    // For other cases, if item is not available or not sending, it requires a note
                    if ((!item.isAvailable || item.notSending) && !item.note) {
                        return true;
                    }
                    return false;
                });

                if (invalidItems.length > 0) {
                    alert("Oops!", 'error', 'Some items require a note because they are marked as not available, not being sent, or have a quantity of 0. Items with a quantity of 0 must also be marked as not being sent.', 'Okay!');
                    return;
                }
            }



            const formattedItems = updatedItems.map(item => {
                const existingItem = order.requestedItems.find(
                    reqItem => reqItem.item._id === item.itemId
                );

                return {
                    item: item.itemId,
                    quantityRequested: existingItem ? existingItem.quantityRequested : item.quantityRequested,
                    quantitySent: item.quantitySent,
                    note: item.note,
                    isAvailable: item.isAvailable,
                    notSending: item.notSending,
                };
            });
            const updatedData = {
                requestedItems: formattedItems,
                finished: isFinished
            };

            const result = await updateOrder(id, updatedData);
            if (result.success) {
                loadOrderDetails()
            } else {
                alert("Oops !", 'error', result.error, 'Okay !')
            }

        } catch (error) {
            alert("Oops !", 'error', "something went wrong, please try again later !", 'Okay !')
        }
    };



    // Updated handleAddItems function with functional state update
    const handleAddItems = async (newItems) => {
        const formattedItems = newItems.map(item => ({
            itemId: item.itemId,
            quantityRequested: item.quantity,
            quantitySent: 0,
            isAvailable: true,
            notSending: false,
        }));

        // Use functional update to ensure latest state
        setUpdatedItems(prevItems => [...prevItems, ...formattedItems]);



        setShouldSubmit(true);
    };




    useEffect(() => {
        if (shouldSubmit) {
            handleSubmit(false, true);
            setShouldSubmit(false);
        }
    }, [updatedItems, shouldSubmit]);



    if (loading) {
        return (
            <Center mt={"20%"}>
                <Loading />
            </Center>
        );
    }

    if (error) {
        return <AccessDenied msg={error} />;
    }
    return (
        <Box maxW="full" mx="auto">
            {/* Client-Entered Details */}
            <HStack align="start" spacing={3} mb={5} flex="1" >
                {order.finished &&
                    // <PdfGeneratorOrders orderDetailsRef={tableRef} name={order?.business?.name} title={"Download"} />
                    <Button colorScheme="teal" onClick={() => window.open(`/print/${order._id}/?hide_side=true`, '_blank')}>
                        Print Order
                    </Button>
                }



                {!order?.finished &&
                    <HStack mt={6} spacing={4} justify="space-between" width="full">
                        <Tooltip label="Add more items to this order" aria-label="Add Items Tooltip" placement={"bottom"}>
                            <Button colorScheme="orange" onClick={openAddItemsModal}>
                                <PlusSquareIcon mr={1} /> Add More Items
                            </Button>
                        </Tooltip>

                        <Tooltip label="Print this order" aria-label="Print Order Tooltip" placement={"bottom"}>
                            <Button colorScheme="teal" onClick={() => window.open(`/print/${order._id}/?hide_side=true`, '_blank')}>
                                Print Order
                            </Button>
                        </Tooltip>



                        <Alert status={"error"} borderRadius={10}>
                            <Box>
                                <AlertDescription>
                                    You are viewing an order that has not been assigned to any client yet !
                                </AlertDescription>
                            </Box>
                        </Alert>


                    </HStack>
                }

            </HStack>

            <Box ref={tableRef} >
                <Box borderWidth="1px" borderRadius="lg" p={6} mb={8} boxShadow="sm" bg={coolors.theadBg}>
                    <Heading size="md" mb={5} >Order Details</Heading>

                    <HStack align="start" spacing={10}>

                        {/* Client-Entered Details */}
                        <VStack align="start" spacing={3} flex="1" borderRight={"1px solid #ccc"}>
                            <Heading size="sm" color="gray.400">Client-Entered Information</Heading>
                            <HStack>
                                <Text fontWeight="bold">Client Name:</Text>
                                <Text>{order.clientName || "N/A"}</Text>
                            </HStack>
                            <HStack>
                                <Text fontWeight="bold">Client Email:</Text>
                                <Text>{order.clientEmail || "N/A"}</Text>
                            </HStack>
                            <HStack>
                                <Text fontWeight="bold">Address:</Text>
                                <Text>{(order.clientAddress.address || "N/A") + ", " + (order.clientAddress.city || "N/A") + ", " + (order.clientAddress.state || "N/A") + ", " + (order.clientAddress.zip || "N/A")}</Text>
                            </HStack>
                            <HStack>
                                <Text fontWeight="bold">Phone:</Text>
                                <Text>{order.clientPhone || "N/A"}</Text>
                            </HStack>
                        </VStack>

                        {/* Order Status */}
                        <VStack align="start" spacing={3} flex="1">
                            <Heading size="sm" color="gray.400">Order Status</Heading>
                            <HStack>
                                <Text fontWeight="bold">Ordered By:</Text>
                                <Text>{order.orderedBy}</Text>
                            </HStack>
                            <HStack>
                                <Text fontWeight="bold">Ordered At:</Text>
                                <Text>{new Date(order.createdAt).toLocaleString()}</Text>
                            </HStack>
                        </VStack>
                    </HStack>
                </Box>

                <Divider />

                <Heading size="md" mb={4} mt={5}>Requested Items</Heading>








                <Table variant="simple" size="md" tableLayout="auto">
                    <Thead bg={coolors.theadBg}>
                        <Tr>
                            <Th width="20%">Item Name</Th>
                            <Th width="10%">Size</Th>
                            <Th width="10%">QR</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {order.requestedItems.map((item, index) => (
                            <Tr
                                key={item?.item?._id}
                                borderBottom={`2px solid ${coolors.borderColor}`}
                                bg={index % 2 === 0 ? coolors.rowBgEven : coolors.rowBgOdd}
                                color={coolors.textColor}
                                height={10}
                                _hover={{ bg: coolors.rowHoverBg, color: "white" }}
                            >
                                <Td>
                                    <strong>{item.item.name}</strong>
                                    <Badge cursor={"default"}>
                                        <Tooltip
                                            label={
                                                item?.addedAt
                                                    ? "Added At " +
                                                    new Date(item?.addedAt).toLocaleDateString() +
                                                    " - " +
                                                    new Date(item?.addedAt).toLocaleTimeString()
                                                    : ""
                                            }
                                        >
                                            <Text fontSize="xs" color={coolors.subTextColor}>
                                                {item?.addedBy?.firstName &&
                                                    "Added By " + item?.addedBy?.firstName}
                                            </Text>
                                        </Tooltip>
                                    </Badge>
                                </Td>
                                <Td>{item.item.size || "N/A"}</Td>
                                <Td>{item.quantityRequested}</Td>
                            </Tr>
                        ))}
                    </Tbody>
                </Table>











                <Center mt={10} mb={10}>
                    <Heading color="gray.400">End of order</Heading>
                </Center>

                <Divider />

                <Heading size="md" mt={4} mb={4}>Client Notes on this order</Heading>
                <Alert mb={5} status={order?.note ? "info" : "error"} borderRadius={10}>
                    <EditIcon boxSize={9} />
                    <Box ml={5}>
                        <AlertTitle mb={5}>Order Notes</AlertTitle>
                        <AlertDescription p={5} mb={5}>
                            {order?.note || "No Notes"}
                        </AlertDescription>
                    </Box>
                </Alert>
            </Box>

            <Divider />

            <Box>
                <OrdersInternalNotes
                    orderId={order?._id}
                    existingNotes={order.internalNotes.reverse() || []}
                    onNoteAdded={handleNoteAdded}
                    addNote={!order.finished}
                />
                <Divider mt={10} />

                {/* <Box mt={10}>
                    <Heading size='md' as={'h5'} mb={5} color="gray.400">Client Last 10 Orders</Heading>
                    <LastTenOrders businessId={order.business._id} />
                </Box> */}
            </Box>


            <AddItemsModal
                isOpen={isAddItemsModalOpen}
                onClose={closeAddItemsModal}
                onAddItems={handleAddItems}
                requestedItems={order?.requestedItems}
            />


        </Box>
    );
};

export default OrderDetailsUnAssigned;
